import React from 'react';
import { Box, IconButton } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import { ScopeSelector } from './ScopeSelector';
import { headerGradient } from './chatConstants';

export function ChatInputBar({
    inputRef,
    inputValue,
    isTyping,
    onInputSync,
    onKeyDown,
    onSendMessage,
    onScopeSelect,
    onScopeDismiss,
    scopePickerOpen,
    onScopePickerOpenChange,
    existingScopeKeys,
    schoolClasses,
    schoolStudents,
}) {
    return (
        <>
            <Box
                className="ai-chatbot-input-wrapper-int"
                sx={{
                    display: 'flex',
                    alignItems: 'flex-end',
                    gap: 0.5,
                    borderRadius: '24px',
                    border: '2px solid rgba(0,0,0,0.12)',
                    bgcolor: '#fff',
                    px: 1.5,
                    py: 0.5,
                    minHeight: 48,
                    transition: 'border-color 0.2s, box-shadow 0.2s',
                    '&:focus-within': {
                        borderColor: 'var(--color-primary-dark, #0d47a1)',
                        boxShadow: '0 0 0 1px var(--color-primary-dark, #0d47a1)',
                    },
                }}
            >
                <Box
                    ref={inputRef}
                    className="ai-chatbot-input ai-chatbot-input-editable"
                    contentEditable={!isTyping}
                    data-placeholder="What would you like to know? Use @ to add a class or student scope."
                    onInput={onInputSync}
                    onKeyDown={onKeyDown}
                    suppressContentEditableWarning
                    sx={{
                        flex: 1,
                        minHeight: 36,
                        maxHeight: 120,
                        py: 0.75,
                        fontFamily: 'var(--font-body)',
                        fontSize: '0.9rem',
                        color: 'text.primary',
                        overflowY: 'auto',
                        whiteSpace: 'pre-wrap',
                        wordWrap: 'break-word',
                        outline: 'none',
                        ...(isTyping && { cursor: 'not-allowed', opacity: 0.8 }),
                    }}
                />
                <IconButton
                    size="small"
                    onClick={() => onSendMessage()}
                    disabled={isTyping || !inputValue.trim()}
                    aria-label="Send"
                    sx={{
                        width: 36,
                        height: 36,
                        ...(inputValue.trim()
                            ? {
                                  background: headerGradient,
                                  color: '#fff',
                                  '&:hover': {
                                      filter: 'brightness(1.08)',
                                      background: headerGradient,
                                  },
                              }
                            : {
                                  bgcolor: 'rgba(0,0,0,0.06)',
                                  color: 'text.disabled',
                                  '&:hover': { bgcolor: 'rgba(0,0,0,0.08)' },
                              }),
                        '&:disabled': { opacity: 0.7 },
                    }}
                >
                    <SendIcon fontSize="small" />
                </IconButton>
            </Box>
            <ScopeSelector
                classes={schoolClasses}
                students={schoolStudents}
                onSelectEntity={onScopeSelect}
                onDismiss={onScopeDismiss}
                disabled={isTyping}
                open={scopePickerOpen}
                onOpenChange={onScopePickerOpenChange}
                existingScopeKeys={existingScopeKeys}
            />
        </>
    );
}
